import React from "react";

function IngresoCandidata() {
    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Ingreso de Candidata</h3>

                    {/* Selección de Cliente */}
                    <div className="mb-3">
                        <label className="form-label">Seleccionar Cliente</label>
                        <div className="input-group">
                            <input type="text" className="form-control" placeholder="Búsqueda de Clientes" />
                            <button className="btn btn-outline-secondary">🔍</button>
                        </div>
                    </div>

                    {/* Datos Personales */}
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Personales</legend>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Rut o Pasaporte</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Nombre</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Primer Apellido</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Segundo Apellido</label>
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label className="form-label">Dirección</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Comuna</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Email</label>
                                <input type="email" className="form-control" />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-3">
                                <label className="form-label">Número de Celular</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Sexo</label>
                                <select className="form-select">
                                    <option value="">Seleccione...</option>
                                    <option value="femenino">Femenino</option>
                                    <option value="masculino">Masculino</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Estatura</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Nacionalidad</label>
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-3">
                                <label className="form-label">Edad</label>
                                <input type="number" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Fecha de Nacimiento</label>
                                <input type="date" className="form-control" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Estado Civil</label>
                                <select className="form-select">
                                    <option value="">Seleccione...</option>
                                    <option value="soltero">Soltero/a</option>
                                    <option value="casado">Casado/a</option>
                                    <option value="divorciado">Divorciado/a</option>
                                    <option value="viudo">Viudo/a</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">N° Hijos Menores de 18</label>
                                <input type="number" className="form-control" />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label className="form-label">Presentación Personal</label>
                                <textarea className="form-control" rows="2"></textarea>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Observaciones iniciales</label>
                                <textarea className="form-control" rows="2"></textarea>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label className="form-label">Cargar Curriculum Vitae</label>
                                <input type="file" className="form-control" />
                            </div>
                        </div>
                    </fieldset>

                    {/* Datos Profesionales */}
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Profesionales</legend>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-label">Título o Diploma</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Institución</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Año</label>
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        {/* Checkbox Profesionales */}
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <label className="form-label">Habilidades Profesionales</label>
                                <div className="d-flex flex-wrap gap-3">
                                    <div>
                                        <input type="checkbox" id="oxigeno" />
                                        <label htmlFor="oxigeno" className="ms-1">Oxígeno Nasal</label>
                                    </div>
                                    <div>
                                        <input type="checkbox" id="sng" />
                                        <label htmlFor="sng" className="ms-1">SNG</label>
                                    </div>
                                    {/* Más checkboxes aquí */}
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    {/* Disponibilidad de Turnos */}
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Disponibilidad de Turnos</legend>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="checkbox" id="turno_24" />
                                    <label className="form-check-label" htmlFor="turno_24">Turno 24 x 24</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="checkbox" id="turno_48" />
                                    <label className="form-check-label" htmlFor="turno_48">Turno 48 x 48</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="checkbox" id="turno_dia" />
                                    <label className="form-check-label" htmlFor="turno_dia">Turno Día</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="checkbox" id="turno_noche" />
                                    <label className="form-check-label" htmlFor="turno_noche">Turno Noche</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="checkbox" id="otros_turnos" />
                                    <label className="form-check-label" htmlFor="otros_turnos">Otros Turnos</label>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    {/* Botón Registrar */}
                    <div className="text-center">
                        <button className="btn btn-primary">Registrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IngresoCandidata;
